import { ApolloError, gql, useMutation } from "@apollo/client";
import { Order } from "../gql/graphql";
import { UserCouponStatus } from "../constants/props";

const CR_USER_COUPON_MUTATION = gql`
  mutation crUserCoupon($input: CrUserCouponInput!) {
    crUserCoupon(input: $input) {
      ok
      err
    }
  }
`;

export interface CrUserCouponInput {
  input: {
    userId: number;
    couponId: number;
  };
}

export interface CrUserCouponMutation {
  crUserCoupon: {
    ok: boolean;
    err: string;
  };
}

export const useCrUserCoupon = (
  onCompleted?: (data: CrUserCouponMutation) => void,
  onError?: (error: ApolloError) => void
) => {
  return useMutation<CrUserCouponMutation, CrUserCouponInput>(
    CR_USER_COUPON_MUTATION,
    {
      onCompleted,
      onError,
    }
  );
};
